<template>
  <div
    class="min-h-[260px] large-desktop:min-h-[300px] p-2 flex flex-col relative bg-transparent"
  >
    <!-- Banner skeleton -->
    <div class="inset-0 absolute bg-fill-brand-hover mask-bottom">
      <Skeleton width="100%" height="300px" border-radius="0" />
    </div>

    <div
      class="flex-1 flex flex-col justify-between overflow-hidden items-stretch max-w-full pb-0 px-3 w-full h-full"
    >
      <div class="flex flex-1 justify-end items-end relative flex-wrap">
        <div class="flex-1 self-end flex flex-col items-start gap-2">
          <!-- Logo skeleton -->
          <div class="avatar">
            <div class="size-16 rounded-lg">
              <Skeleton width="64px" height="64px" border-radius="8px" />
            </div>
          </div>

          <!-- Title skeleton -->
          <Skeleton width="200px" height="28px" border-radius="4px" />

          <!-- Member button skeleton -->
          <Skeleton width="180px" height="49px" border-radius="20px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";
</script>

<style scoped>
.mask-bottom {
  mask-image: linear-gradient(to bottom, #000 0%, transparent 100%);
}
</style>
